import { Eyebrow, Reveal } from "../site/motion";

const BADGES = [
  { big: "100g", small: "bar", tone: "bg-dano-gold text-dano-ink" },
  { big: "~25g", small: "protein", tone: "bg-dano-red text-dano-cream" },
  { big: "Real food", small: "ingredients", tone: "bg-dano-ink text-dano-cream" },
];

export const MoreThanSnack = () => (
  <section data-testid="more-than-snack" className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
    <div className="grid gap-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <Eyebrow>Why Dano Bars</Eyebrow>
        <h2 className="mt-4 font-wide text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.92]" data-testid="more-than-snack-title">
          More Than a Snack. <span className="text-dano-red">Real Food.</span> Real Flavor.
        </h2>
      </Reveal>
      <Reveal className="lg:col-span-6" delay={0.1}>
        <div className="space-y-5 text-base sm:text-lg leading-relaxed text-dano-ink/85" data-testid="more-than-snack-copy">
          <p>Dano Bars are premium, handcrafted protein bars made with real, recognizable ingredients. You can taste the real ingredients in every bite.</p>
          <p>Unlike traditional protein bars that can be small, chalky, or overly processed, Dano Bars are designed to be bigger, softer, chewier, and extremely delicious.</p>
          <p>Each substantial 100g bar is packed with approximately 25g of protein, the perfect balance between a quick snack and something more satisfying.</p>
          <p>Whether you're heading to the gym, working long hours, traveling, or simply looking for convenient nutrition, Dano Bars are made to keep you fueled.</p>
        </div>
      </Reveal>
    </div>
    <div className="mt-12 sm:mt-16 grid gap-4 sm:grid-cols-3">
      {BADGES.map((b, i) => (
        <Reveal key={b.small} delay={i * 0.08}>
          <div data-testid={`highlight-badge-${i}`} className={`flex min-w-0 flex-wrap items-baseline justify-between gap-x-3 gap-y-1 rounded-full px-6 sm:px-7 py-5 transition-transform duration-500 hover:-translate-y-1 ${b.tone}`}>
            <span className="font-wide text-xl sm:text-2xl lg:text-3xl whitespace-nowrap">{b.big}</span>
            <span className="font-cond text-base uppercase tracking-[0.2em]">{b.small}</span>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
